import React, { useState, useEffect } from 'react'

// redux
import { connect } from "react-redux";

// react router
import { useHistory } from "react-router-dom";

// redux actions
import {
    saveCommonTokenToStore,
    saveCurrentUserToStore,
    setTempOrderId,
} from "redux/actions/actionAuth";
import { setCartDetails, setCartImages, setCartItem } from 'redux/actions/actionCart';
import { setGlobalLoading } from 'redux/actions/actionCommon';

// bootstrap
import { Spinner, Modal } from "react-bootstrap";

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from "react-toastify";

// helpers functions
import { saveToLocalStorage } from 'utlis/helpers/Common/CommonHelperFunctions';

// auth api
import { userLogin } from "utlis/Apis/Auth_API";
// cart api
import { mergeCartItems } from 'utlis/Apis/Cart_API';

// modal
import ResetPasswordModal from '../../Modals/ResetPasswordModal';

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED,
    LOGIN_SUCCESS,
} from "utlis/AppMessages/AppMessages";

function StepLogin(props) {
    // props
    const {
        setGlobalLoading,
        setSectionLoading,

        saveCurrentUserToStore,

        tempOrderId,
        setTempOrderId,

        setCartDetails,
        setCartItem,
        setCartImages,
        setRightMenuVisibility,

        existingEmail
    } = props

    // consts
    const name_to_save_on_local_storage = `__toi_dd`
    const history = useHistory();

    // states
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false)

    const [resetPasswordModalVisibility, setResetPasswordModalVisibility] = useState(false)

    // initial form values
    const initialFormValues = {
        email: '',
        password: '',
        rememberMe: false,
    }

    // handle form validations
    const formValidationSchema = Yup.object({
        email: Yup.string().email().required('This field is required'),
        password: Yup.string().min(6, "the password must be at least six characters long").required("This field is required"),
        rememberMe: Yup.boolean(),
    })
    
    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // enabling button loading and disabling button
            setBtnDisabled(true);
            setSectionLoading(true);

            // login the user API
            userLogin(values.email, values.password).then((res) => {
                const resData = res.data;

                // if the request is success
                if (resData.success) {
                    const userData = resData.data;

                    // generating user details
                    const currentUser = {
                        loggedOn: new Date(),
                        canExpire: false,
                        email: userData.email,
                        firstName: userData.first_name,
                        lastName: userData.last_name,
                        userId: userData.user_id,
                        userToken: userData.user_token,
                        tempOrderId: userData.temp_order_id,
                    };

                    // merging cart items with the already selected cart items by user
                    mergeCartItems(currentUser.userToken, {
                        customerId: currentUser.userId,
                        from: tempOrderId,
                        to: currentUser.tempOrderId ?? ""
                    }).then(res => {
                        const resData = res.data

                        // disabling button loading and enabling button
                        setBtnDisabled(false);
                        setSectionLoading(false);

                        // if request is success
                        if (resData.success) {
                            const accData = resData.data

                            // setting new temp order id
                            setTempOrderId(resData.temp_order_id)
                            saveToLocalStorage(name_to_save_on_local_storage, resData.temp_order_id)

                            // setting cart items details
                            setCartItem(accData.content);
                            setCartImages(accData.images);
                            setCartDetails({
                                cart_discount: accData.cart_discount,
                                cart_items: accData.cart_items,
                                cart_qty: accData.cart_qty,
                                cart_sub_total: accData.cart_sub_total,
                                cart_total: accData.cart_total,
                                coupon_code: accData.coupon_code,
                                coupon_value: accData.coupon_value,
                                allCartData: accData
                            });

                            // saving user to store
                            saveCurrentUserToStore(currentUser);

                            // then saving the user to the local storage
                            saveToLocalStorage("__uu_dd", JSON.stringify(currentUser));

                            // disabling button loading
                            setBtnLoading(false);

                            // disabling global loading
                            setGlobalLoading(false)

                            setRightMenuVisibility(false)

                            // dismissing all the previous toasts first
                            toast.dismiss();

                            // showing the error message
                            toast.success(LOGIN_SUCCESS, {
                                autoClose: 2000,
                                onClose: () => {
                                    window.location.reload()

                                    // moving to checkout
                                    // history.push({
                                    //     pathname: "/checkout",
                                    //     state: {
                                    //         allowNavigation: true
                                    //     }
                                    // })
                                }
                            });
                        }

                        // if request has some errors
                        if (resData.error) {
                            // dismissing all the previous toasts first
                            toast.dismiss();

                            // showing the error message
                            toast.error(resData.message || "Unknown error occured", {
                                autoClose: 2500
                            });
                        }
                    }).catch((err) => {
                        console.log(`${ERROR_WHILE__NAME} mergeCartItems `, err.message);

                        // disabling button loading and enabling button
                        setBtnDisabled(false);
                        setSectionLoading(false);

                        // dismissing all the previous toasts first
                        toast.dismiss();

                        // showing the error message
                        toast.error(UNKNOWN_ERROR_OCCURED, {
                            autoClose: 3000
                        });
                    });
                }

                // if there's any error
                if (resData.error) {

                    // disabling button loading and enabling button
                    setBtnDisabled(false);
                    setSectionLoading(false);

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(resData.message || "Unknown error occured", {
                        autoClose: 2500
                    });
                }
            }).catch((err) => {
                console.log(`${ERROR_WHILE__NAME} userLogin `, err.message);

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 3000,
                    onClose: () => {
                        // disabling button loading and enabling button
                        setBtnDisabled(false);
                        setSectionLoading(false);
                    },
                });
            });
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // if existing email exists
    useEffect(() => {
        if (existingEmail) {
            const elemWrapper = document.querySelector(".right-checkbout-bar > .inner")
            const elem = document.querySelector("#login-view-frac")

            if (elemWrapper && elem) {
                elemWrapper.scrollTo(0, (elem.offsetTop - 10)) // scrolling to login page
            }

            formik.setFieldValue("email", existingEmail)
            formik.setFieldValue("password", "")
            formik.setFieldValue("rememberMe", false)
        }
    }, [existingEmail])

    // reset passowrd
    const handleResetPasswordModalClose = () => {
        // reset passowrd modals
        setResetPasswordModalVisibility(false)
    }


    return (
        <React.Fragment>
            <div className="frac" id="login-view-frac">
                <div className="header-sec">
                    <p className="head st-fs-19 st-fw-800 mb-2">Returning Customers</p>
                    <p className="desc mb-0">Sign in for faster checkout and to save info for next time.</p>
                    <div className="text-end st-fs-13 mt-1">
                        <a href="/" className="text-decoration-underline text-capitalize"
                            onClick={ev => {
                                ev.preventDefault()
                                // show modal
                                setResetPasswordModalVisibility(true)
                            }}>
                            reset password
                        </a>
                    </div>
                </div>

                <div className="content-sec">
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        {/* input field */}
                        <div className={`form-item mb-3 ${(formik.touched.email && formik.errors.email) ? "has-error" : ""}`}>
                            <label className="mb-2 st-fw-800">Email <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                            <input
                                type="email"
                                className="form-control rounded-0"
                                {...formik.getFieldProps('email')}
                            />
                            {
                                (formik.touched.email && formik.errors.email) ? (
                                    <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                        {formik.errors.email}
                                    </div>
                                ) : null
                            }
                        </div>

                        {/* input field */}
                        <div className={`form-item mb-3 ${(formik.touched.password && formik.errors.password) ? "has-error" : ""}`}>
                            <label className="mb-2 st-fw-800">Password <span className="st-fw-400 st-fs-13 position-relative ms-2 text-black-50" style={{ top: -0.5 }}>required</span></label>
                            <input
                                type="password"
                                className="form-control rounded-0"
                                {...formik.getFieldProps('password')}
                            />
                            {
                                (formik.touched.password && formik.errors.password) ? (
                                    <div className="error-msg st-fs-12 text-danger position-relative" style={{ top: 3 }}>
                                        {formik.errors.password}
                                    </div>
                                ) : null
                            }
                        </div>

                        <div className="remember mb-3">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={formik.values.rememberMe}
                                    {...formik.getFieldProps('rememberMe')}
                                />
                                <span className="ms-2 position-relative" style={{ top: -1 }}>Remember Me</span>
                            </label>
                        </div>

                        <div className="btns pt-1">
                            <button
                                type="submit"
                                className="btn rounded-0 btn-block text-uppercase st-fw-800 default-btn"
                                disabled={btnDisabled}>
                                {
                                    btnLoading ? (
                                        <Spinner animation="border" size="sm" />
                                    ) : (
                                        <span>sign in</span>
                                    )
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* modals */}
            <Modal show={resetPasswordModalVisibility} onHide={handleResetPasswordModalClose}>
                <Modal.Body>
                    <ResetPasswordModal
                        email={formik.values.email}
                        closeModal={handleResetPasswordModalClose}
                    />
                </Modal.Body>
            </Modal>

        </React.Fragment>
    )
}


const getDataFromStore = (state) => {
    return {
        tempOrderId: state.auth.tempOrderId,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        saveCommonTokenToStore: (token) => dispatch(saveCommonTokenToStore(token)),
        saveCurrentUserToStore: (user) => dispatch(saveCurrentUserToStore(user)),
        setCartDetails: cartDetails => dispatch(setCartDetails(cartDetails)),
        setCartItem: cartData => dispatch(setCartItem(cartData)),
        setCartImages: cartData => dispatch(setCartImages(cartData)),
        setTempOrderId: orderId => dispatch(setTempOrderId(orderId)),
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(StepLogin);